import { useEffect, useState } from "react";
import {
  useGetCreditCardExaminationsQuery,
  usePostPriorPayoutCreditCardMerchantNumbersMutation,
} from "../../features/api";
import {
  CreditCardExamination,
  CreditCardExaminationsRequest,
  PriorPayoutCreditCardMerchantNumbersRequest,
} from "../../features/api-interfaces";
import Main from "./Main";
import { CONFIGS, LABELS } from "./constants";
import { useSearchParams } from "react-router-dom";
import { getMessageItemList } from "../UI/table/ErrorTable";
import { SelectProps } from "@cloudscape-design/components-themed";

/**
 * クレカ加盟店番号登録表示
 * ID払い出し結果受領・取込の表示に必要な以下の内容を設定する。
 *  事前払出ID名
 *  登録API呼び出し処理
 *  入力IDリスト
 *  入力IDリスト設定処理
 *  スピナー表示フラグ
 *  ドロップダウンリスト表示内容
 *  ドロップダウンリスト選択アイテム
 *  ドロップダウンリスト選択アイテム設定処理
 *
 * @param props.setErrorMessageList エラーメッセージリスト
 */
const PriorPayoutCreditCardMerchantNumbers = (props: any) => {
  // クエリパラメータ取得
  const [searchParams] = useSearchParams();

  // スピナー表示処理用
  const [spinnerDisplayFlag, isSpinnerDisplayFlag] = useState(false);

  // クレカ加盟店番号登録API
  const [priorPayoutCreditCardMerchantNumberRegister] =
    usePostPriorPayoutCreditCardMerchantNumbersMutation();

  // クレカ審査依頼先取得APIリクエスト
  const creditCardExaminationsRequest = {
    // 事前払出対象フラグ:trueのレコードを取得する。
    priorPayoutTarget: 1,
  } as CreditCardExaminationsRequest;
  // クレカ審査依頼先取得API
  let { data } = useGetCreditCardExaminationsQuery(
    creditCardExaminationsRequest
  );

  // 審査対象ブランド
  const [examinationTargetBrand, setExaminationTargetBrand] =
    useState<SelectProps.Option>({
      label: "",
      value: "",
    });

  // 入力IDリスト
  const [idList, setIdList] = useState("");

  // ドロップダウン表示アイテムリスト
  const [selectItemList, setSelectItemList] = useState<SelectProps.Option[]>(
    []
  );

  // 初回のみエラーメッセージリストの初期化を行う
  useEffect(() => {
    props.setErrorMessageList([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ドロップダウン表示アイテムリストの作成処理
  const createSelectItemList = (items: CreditCardExamination[]) => {
    let selectItemList: SelectProps.Option[] = [];

    for (const item of items) {
      const selectItem = {
        label: item.orderTargetName,
        value: item.orderTargetCode.toString(),
      } as SelectProps.Option;

      selectItemList.push(selectItem);
    }

    return selectItemList;
  };

  useEffect(() => {
    // ドロップダウンリストの設定
    const examinationTargetBrandList = data ? createSelectItemList(data) : [];
    setSelectItemList(examinationTargetBrandList);

    // ドロップダウンリストの初期表示値を設定
    for (const selectItem of examinationTargetBrandList) {
      if (
        selectItem.value ===
        searchParams.get(CONFIGS.QUERY_PARAMETER_ORDER_TARGET_CODE)
      ) {
        // クエリパラメータの値と一致する審査対象ブランドを設定する。一致しない場合は初期値のまま表示する。
        setExaminationTargetBrand(selectItem);
      }
    }
  }, [data, searchParams]);

  // 登録API呼び出し処理
  const callRegisterApi = () => {
    // 入力IDリストを改行で分割後、空文字を除外してrequestに設定
    const request = {
      orderTargetCode: Number(examinationTargetBrand.value),
      merchantNumberList: idList.split(CONFIGS.LF_CODE).filter((s) => {
        return s !== "";
      }),
    } as PriorPayoutCreditCardMerchantNumbersRequest;

    // スピナー表示
    isSpinnerDisplayFlag(true);
    // API呼び出し
    priorPayoutCreditCardMerchantNumberRegister(request)
      .unwrap()
      .then((res) => {
        // スピナー非表示
        isSpinnerDisplayFlag(false);

        if ("error" === res.status) {
          if (
            res.detailMessageList !== null &&
            res.detailMessageList.length !== 0
          ) {
            props.setErrorMessageList(
              getMessageItemList(res.detailMessageList)
            );
          }
        } else {
          // 正常終了時には画面表示を初期表示時と同様になるように設定
          setIdList("");
          props.setErrorMessageList([]);
          setExaminationTargetBrand({
            label: "",
            value: "",
          });
        }
      });
  };

  return (
    <Main
      priorPayoutIdName={LABELS.CREDIT_CARD_MERCHANT_NUMBERS}
      callRegisterApi={callRegisterApi}
      idList={idList}
      setIdList={setIdList}
      selectItemName={LABELS.ORDER_TARGET_NAME}
      selectItem={examinationTargetBrand}
      setSelectItem={setExaminationTargetBrand}
      selectList={selectItemList}
      spinnerDisplayFlag={spinnerDisplayFlag}
      placeholder={LABELS.CREDIT_CARD_TEXT_AREA_PLACE_HOLDER}
    ></Main>
  );
};

export default PriorPayoutCreditCardMerchantNumbers;
